import React from 'react';
import logoImg from '../assets/images/logo.png';
import commentsImg from '../assets/images/comment.png';
import '../styles/TestimonialsSection.css';

const TestimonialsSection = () => {
  const testimonials = [
    // {
    //   id: 1,
    //   name: "Jane Cooper",
    //   role: "12/4/17",
    //   rating: 5,
    //   comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
    //   avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face"
    // },
    {
      id: 2,
      name: "John Doe",
      role: "11/3/17",
      rating: 5,
      comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Sarah Wilson",
      role: "10/2/17",
      rating: 5,
      comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=60&h=60&fit=crop&crop=face"
    },
    {
      id: 4,
      name: "Mike Johnson",
      role: "09/1/17",
      rating: 5,
      comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face"
    },
    {
      id: 5,
      name: "Emily Davis",
      role: "08/15/17",
      rating: 5,
      comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
      avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=60&h=60&fit=crop&crop=face"
    },
    {
      id: 6,
      name: "David Brown",
      role: "07/20/17",
      rating: 5,
      comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem velit viverra amet faucibus.",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=60&h=60&fit=crop&crop=face"
    }
  ];

  return (
    <div className="testimonials-section">
      <div className="testimonials-container">
        <div className="container">
          <div className="content-wrapper">
            {/* Left Side - Logo and Background Elements */}
            <div className="left-section">
              <div className="logo-container">
                <div className="main-logo">
                  <img 
                    src={logoImg}
                    alt="Customer Comments and Reviews" 
                    className="logo-svg"
                  />
                </div>
              </div>
              <div className="background-circles">
                <div className="circle-1"></div>
                <div className="circle-3"></div>
              </div>
            </div>

            {/* Right Side - Testimonials */}
            <div className="right-section">
              <div className="testimonials-header">
                <h2 className="testimonials-title">
                  What <span className="highlight-text">Our Member's</span><br />
                  Saying About Us
                </h2>
                <div className="member-avatars">
                  {testimonials.slice(0, 6).map(testimonial => (
                    <img
                      key={testimonial.id}
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="member-avatar"
                    />
                  ))}
                  <span className="member-count">100+ Reviews</span>
                </div>
              </div>

              {/* Comment Image with Radial Blur */}
              <div className="comment-image-container">
                <div className="comment-image-wrapper">
                  <img 
                    src={commentsImg}
                    alt="Customer Comments and Reviews" 
                    className="comment-image"
                  />
                  <div className="radial-blur-overlay"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;